import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import { getEntity, removeEntity } from "../../common/CommonFunctions";
import MUIButton from "../../components/MUIButton/MUIButton";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import "./SingleMagazine.style.css";

const MagazinePage = () => {
  const entity = useMemo(() => getEntity(), []);
  const navigate = useNavigate();
  const title =
    entity?.title || entity?.name || entity?.topicName || "Magazine";

  // Try common fields for heyzine link
  const heyzineUrl =
    entity?.srcLink ||
    entity?.url ||
    "";

  return (
    <div className="magp-page">
      <div className="magp-content">
        <Typography className="magp-title">{title}</Typography>

        <div className="magp-view">
          {/* Back Button */}
          <div className="magp-back-button-container">
            <MUIButton
              primary
              children={"Back"}
              startIcon={<ArrowBack />}
              className="magp-back-button"
              variant="outlined"
              color="primary"
              size={"small"}
              onClick={() => {
                removeEntity()
                navigate("/")
              }}
            />
          </div>
          <div className="magp-iframe-container">
            {heyzineUrl ? (
              <iframe
                title={title}
                className="magp-iframe"
                src={heyzineUrl}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <Typography variant="body1">
                Magazine link not available.
              </Typography>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MagazinePage;